import { render, staticRenderFns } from "./ItemIntro.vue?vue&type=template&id=7c05f6d8&scoped=true&lang=pug"
import script from "./ItemIntro.vue?vue&type=script&lang=ts"
export * from "./ItemIntro.vue?vue&type=script&lang=ts"
import style0 from "./ItemIntro.vue?vue&type=style&index=0&id=7c05f6d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05f6d8",
  null
  
)

export default component.exports